interface CatalogEditorActionsProps {
  isSaving: boolean;
  isDirty: boolean;
  isCreating: boolean;
  onCancel: () => void;
}

export function CatalogEditorActions({ isSaving, isDirty, isCreating, onCancel }: CatalogEditorActionsProps) {
  return (
    <>
      <span className="catalog-save-state" role="status">{isDirty ? 'Есть изменения' : isCreating ? 'Новая карточка' : 'Все изменения сохранены'}</span>
      <button className="catalog-button" disabled={isSaving} onClick={onCancel} type="button">Отмена</button>
      <button className="catalog-button catalog-button_primary" disabled={isSaving} type="submit">{isSaving ? 'Сохраняем…' : isCreating ? 'Создать' : 'Сохранить изменения'}</button>
    </>
  );
}
